/* eslint-disable max-lines */
import type { SupportCategory, SupportSubcategory, SupportSubcategoryQuestion } from './types';

export const IT_CATEGORIES: SupportCategory[] = [
  { id: 'it-computers-ipads', label: 'Computers & Ipads', departmentId: 'IT' },
  { id: 'it-security-alarms', label: 'Security and Fire Alarms', departmentId: 'IT' },
  { id: 'it-cameras', label: 'Cameras', departmentId: 'IT' },
  { id: 'it-door-codes', label: 'Door Codes', departmentId: 'IT' },
  { id: 'it-clickers', label: 'Clickers', departmentId: 'IT' },
  { id: 'it-internet', label: 'Internet', departmentId: 'IT' },
  { id: 'it-phones', label: 'Phones', departmentId: 'IT' },
  { id: 'it-printers', label: 'Printers', departmentId: 'IT' },
];

export const IT_SUBCATEGORIES: SupportSubcategory[] = [
  { id: 'it-computers-windows', label: 'Windows Computer', categoryId: 'it-computers-ipads' },
  { id: 'it-computers-apple', label: 'Apple Computer', categoryId: 'it-computers-ipads' },
  { id: 'it-computers-ipad', label: 'Apple Ipad', categoryId: 'it-computers-ipads' },
  { id: 'it-security-alarms', label: 'Security and Fire Alarms', categoryId: 'it-security-alarms' },
  { id: 'it-cameras', label: 'Cameras', categoryId: 'it-cameras' },
  { id: 'it-door-codes', label: 'Door Codes', categoryId: 'it-door-codes' },
  { id: 'it-clickers', label: 'Clickers', categoryId: 'it-clickers' },
  { id: 'it-internet', label: 'Internet', categoryId: 'it-internet' },
  { id: 'it-phones', label: 'Phones', categoryId: 'it-phones' },
  { id: 'it-printers', label: 'Printers', categoryId: 'it-printers' },
];

const STANDARD_QUESTIONS = (subcategoryId: string, prefix: string): SupportSubcategoryQuestion[] => [
  { id: `${prefix}-1`, subcategoryId, type: 'text', label: 'Subject', required: true },
  {
    id: `${prefix}-2`,
    subcategoryId,
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  { id: `${prefix}-3`, subcategoryId, type: 'date', label: 'Date needed by', required: true },
  { id: `${prefix}-4`, subcategoryId, type: 'file', label: 'Select A file', required: false },
];

const [CAMERAS_SUBJECT, ...CAMERAS_OTHER_QUESTIONS] = STANDARD_QUESTIONS('it-cameras', 'it-cameras-q');

export const IT_QUESTIONS: SupportSubcategoryQuestion[] = [
  {
    id: 'it-windows-1',
    subcategoryId: 'it-computers-windows',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'it-windows-2',
    subcategoryId: 'it-computers-windows',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'it-windows-3',
    subcategoryId: 'it-computers-windows',
    type: 'date',
    label: 'Date needed by',
    required: true,
  },
  {
    id: 'it-windows-4',
    subcategoryId: 'it-computers-windows',
    type: 'file',
    label: 'Select A file',
    required: false,
  },
  {
    id: 'it-apple-pc-1',
    subcategoryId: 'it-computers-apple',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'it-apple-pc-2',
    subcategoryId: 'it-computers-apple',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'it-apple-pc-3',
    subcategoryId: 'it-computers-apple',
    type: 'text',
    label: 'Serial Number',
    required: false,
  },
  {
    id: 'it-apple-pc-4',
    subcategoryId: 'it-computers-apple',
    type: 'text',
    label: 'If changing owners, who should be the new owner',
    required: false,
  },
  {
    id: 'it-apple-pc-5',
    subcategoryId: 'it-computers-apple',
    type: 'date',
    label: 'Date needed by',
    required: true,
  },
  {
    id: 'it-apple-pc-6',
    subcategoryId: 'it-computers-apple',
    type: 'file',
    label: 'Select A file',
    required: false,
  },
  {
    id: 'it-apple-ipad-1',
    subcategoryId: 'it-computers-ipad',
    type: 'text',
    label: 'Subject',
    required: true,
  },
  {
    id: 'it-apple-ipad-2',
    subcategoryId: 'it-computers-ipad',
    type: 'textarea',
    label: 'Description',
    required: true,
  },
  {
    id: 'it-apple-ipad-3',
    subcategoryId: 'it-computers-ipad',
    type: 'text',
    label: 'Serial Number',
    required: false,
  },
  {
    id: 'it-apple-ipad-4',
    subcategoryId: 'it-computers-ipad',
    type: 'date',
    label: 'Date needed by',
    required: true,
  },
  {
    id: 'it-apple-ipad-5',
    subcategoryId: 'it-computers-ipad',
    type: 'file',
    label: 'Select A file',
    required: false,
  },
  ...STANDARD_QUESTIONS('it-security-alarms', 'it-security'),
  CAMERAS_SUBJECT,
  { id: 'it-cameras-q-room', subcategoryId: 'it-cameras', type: 'text', label: 'Room', required: true },
  ...CAMERAS_OTHER_QUESTIONS,
  ...STANDARD_QUESTIONS('it-door-codes', 'it-door'),
  ...STANDARD_QUESTIONS('it-clickers', 'it-clickers-q'),
  ...STANDARD_QUESTIONS('it-internet', 'it-internet-q'),
  ...STANDARD_QUESTIONS('it-phones', 'it-phones-q'),
  ...STANDARD_QUESTIONS('it-printers', 'it-printers-q'),
];
